import useSWR from 'swr'
import {useToken} from "../auth/token";
import API from "../../../utils/api";
interface ResponseTypes {
  media: any;
}
const M_KEY = '/agent/media/v2'; // 디지털사이니지 v2 조회

const fetchKey = () =>
	`${M_KEY}`;

export function useAgentMediaList() {
	const { data: token } = useToken();

	const KEY = fetchKey();


	const fetcher = () => fetchAPI(KEY, token);
	const { data, mutate } = useSWR(token ? `${KEY}` : null, fetcher, {
		revalidateOnFocus: false,
		revalidateOnReconnect: false,
		refreshInterval: 3600000,
	});


  return { agentMediaList: data?.media ?? null, mutateAgentMediaList: mutate };
}

async function fetchAPI(KEY:string, token:any): Promise<ResponseTypes> {
	try {
		const response = await API.get(`${KEY}`, token + '', {});
		return { media: response.result || null };
	} catch (error) {
		console.error('Failed to fetch Agent Media List:', error);

		return { media: null };
	}
}
